import React from 'react';
import { useTranslation } from 'react-i18next';
import SelectWithoutTokens from './SelectWithoutTokens';
import {createCategoriesList} from "../components/helper";

const ItemProductCategory = ({itemsStorageService}) => {
    const { i18n } = useTranslation();
    const changeProductCategory = (form) => {
        itemsStorageService.updateProductCategory(form.id);
    };
    const getProductCategoryTitle = (formGroup) => {
        if(formGroup) {
            return i18n.t(`product.scheme.formGroup.${formGroup}`);
        } else {
            return '';
        }
    };
    const options = typeof itemsStorageService.getFormGroupOptions === 'function'
        ? itemsStorageService.getFormGroupOptions()
        : createCategoriesList(itemsStorageService.needToAddAny());
    return (
        <label className="block__content product__form-label product__form-item" key={itemsStorageService.getProductCategory() + 'label'}>
            <span className="block__text product__form-label_text">{itemsStorageService.getLabelValue()}</span>
            <SelectWithoutTokens
                listOfOptions={options}
                handleChangeValue={changeProductCategory}
                titleValue={getProductCategoryTitle(itemsStorageService.getProductCategory())}/>
        </label>
    );
};

export default ItemProductCategory;
